var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromotionNavIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.987 7 .997-1.406a2.443 2.443 0 1 0-3.987-2.824L12 7M5.264 7 4.33 5.827a2.634 2.634 0 1 1 4.12-3.283L12 7",
    stroke: "#062F6D",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 7,
    width: 20,
    height: 6,
    rx: 1,
    stroke: "#062F6D",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 13h16v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8Z",
    stroke: "#062F6D",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionNavIconActive);
export default __webpack_public_path__ + "static/media/promotion-nav-icon-active.8d65618907e6b95d5e752fe733923880.svg";
export { ForwardRef as ReactComponent };